import { DefaultClock } from './_default_clock.js';
export function createClock(resolution, fetchExternalDate, syncInterval) {
    return new DefaultClock(resolution, fetchExternalDate, syncInterval);
}
//# sourceMappingURL=clock.js.map